$(window).scroll(function() {
    if ($('.shopify-section--traditional-method').length > 0) {
      var backHeight = $('.line-vertical-s').height();

      var skl = $(window).scrollTop() - $('.shopify-section--traditional-method').offset().top;
      skl +=300;
      if (skl < 0) skl = 0;
      if (skl > backHeight) skl = backHeight;

      $('.line-vertical').css('height', skl+'px');

      $('#timeline > .vs-grid').each(function() {
        if ($(this).position().top < skl-20+10) {
          $(this).addClass('lined');
        } else {
          $(this).removeClass('lined');
        }
      });
    }
});

$('.product_gallery_nav').flickity({
  "cellAlign": 'left',
  "asNavFor": ".product_gallery",
  "draggable": false,
  "percentPosition": false,
  "groupCells": "100%",
  "pageDots": false
})

var banner = {
  init: function(){
    if ($('.parallax-banner').hasClass('parallax_effect--true')){
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() > 798) {
        skrollr.init({forceHeight: false});

        var s = skrollr.init({forceHeight: false});
        s.refresh($(".bcg"));
        $(".slideshow-section").waypoint(function() {
          var evt = document.createEvent('UIEvents');
              evt.initUIEvent('resize', true, false, window, 0);
              window.dispatchEvent(evt);
        }, { offset: '100%' });
      } else if ($(window).width() > 798) {
        $('.parallax-banner').removeClass('parallax_effect--true').addClass('parallax_effect--false');
      }
    }

    //promo banner is enabled
    if ($('.promo_banner').length) {
      $('body').addClass('promo_banner--active');
    } else {
      $('body').removeClass('promo_banner--active');
    }

    animate_content.init();
    $(".scroll-arrow").smoothScroll();
  },
  unload: function($target){
  }
}

var animate_content = {
  init: function() {
    if ($(window).width() > 798 || $(window).width() == 0) {
      $(".animate_right").waypoint(function() {
        $(this.element).addClass("animated fadeInRight");
      }, { offset: '80%' });
      $(".animate_left").waypoint(function() {
        $(this.element).addClass("animated fadeInLeft");
      }, { offset: '80%' });
      $(".animate_up").waypoint(function() {
        $(this.element).addClass("animated fadeInUp");
      }, { offset: '80%' });
      $(".animate_in").waypoint(function() {
        $(this.element).addClass("animated fadeIn");
      }, { offset: '80%' });
      $(".animate_down").waypoint(function() {
        $(this.element).addClass("animated fadeInDown");
      }, { offset: '80%' });
    }
  }
}

$(document).on('click', '.filter-contianer .filter-heading', function (e) {
  if ($(window).width() < 798) {
    if ($('.filter-contianer .filter-content').hasClass('active')) {
      $('.filter-contianer .filter-content').removeClass('active');
    } else {
      $('.filter-contianer .filter-content').addClass('active');
    }
    
  }
})

// Advanced components 

if (!customElements.get('product-quickadd')) {
	class productQuickAdd extends HTMLElement {

		constructor() { super(); }

		connectedCallback() {
			this.variantSelector = this.querySelector('select');
      this.variantWrapper = this.querySelector('.product-quickadd__variants');
      this.variantToggle = this.querySelector('.product-quickadd__variant-toggle');
      this.quickAddSubmit = this.querySelector('button');
			this.init();
		}

		init() {

      if (this.variantToggle) {
        this.variantToggle.addEventListener('click', e => {
          this.classList.add('variants-display');
        });
      }

			this.variantSelector.addEventListener('change', e => {
				e.preventDefault();
        this.parentElement.querySelector('.current_price').innerHTML = e.target.options[e.target.selectedIndex].dataset.price;
			});
		}
	}

	customElements.define('product-quickadd', productQuickAdd);
}
